import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Alert from "../../components/Alert";
import { createLookupApi } from "../../api/lookupApi";
import { listClassConfigurations } from "../../api/classConfigurationApi";
import { listPeriodTimeConfigs, savePeriodTimeConfig, deletePeriodTimeConfig } from "../../api/attendanceApi";
import "../Users/UsersPage.css";

const periodApi = createLookupApi("periods");

export default function PeriodTimeConfigPage() {
  const [configs, setConfigs] = useState([]);
  const [classConfigurations, setClassConfigurations] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [form, setForm] = useState({ classConfigurationId: "", periodId: "", startTime: "", endTime: "" });

  const load = () => {
    setLoading(true);
    Promise.all([listPeriodTimeConfigs(), listClassConfigurations(), periodApi.list()])
      .then(([configList, classList, periodList]) => {
        setConfigs(configList);
        setClassConfigurations(classList);
        setPeriods(periodList);
      })
      .catch(() => setError("Failed to load period time configurations."))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await savePeriodTimeConfig({
        classConfigurationId: Number(form.classConfigurationId),
        periodId: Number(form.periodId),
        startTime: form.startTime,
        endTime: form.endTime,
      });
      setSuccess("Period time configuration saved.");
      setForm({ classConfigurationId: "", periodId: "", startTime: "", endTime: "" });
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to save.");
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm(`Delete time configuration for "${row.classConfigName} / ${row.periodName}"?`)) return;
    setError("");
    try {
      await deletePeriodTimeConfig(row.id);
      setSuccess("Deleted.");
      setConfigs((prev) => prev.filter((c) => c.id !== row.id));
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to delete.");
    }
  };

  const columns = [
    { key: "classConfigName", label: "Class" },
    { key: "periodName", label: "Period" },
    { key: "startTime", label: "Start" },
    { key: "endTime", label: "End" },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Attendance Period Time Setup</h1>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      <form onSubmit={handleSubmit} className="user-form" style={{ marginBottom: 24 }}>
        <label>Class</label>
        <select value={form.classConfigurationId} onChange={(e) => setForm({ ...form, classConfigurationId: e.target.value })} required>
          <option value="" disabled>
            Select a class
          </option>
          {classConfigurations.map((c) => (
            <option key={c.id} value={c.id}>
              {c.classConfigName}
            </option>
          ))}
        </select>
        <label>Period</label>
        <select value={form.periodId} onChange={(e) => setForm({ ...form, periodId: e.target.value })} required>
          <option value="" disabled>
            Select a period
          </option>
          {periods.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
        <label>Start Time</label>
        <input type="time" value={form.startTime} onChange={(e) => setForm({ ...form, startTime: e.target.value })} required />
        <label>End Time</label>
        <input type="time" value={form.endTime} onChange={(e) => setForm({ ...form, endTime: e.target.value })} required />
        <div className="form-actions">
          <button type="submit" className="btn-primary">
            Save
          </button>
        </div>
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          rows={configs}
          actions={(row) => (
            <button type="button" className="btn-link danger" onClick={() => handleDelete(row)}>
              Delete
            </button>
          )}
        />
      )}
    </MainLayout>
  );
}
